// Admin bo'limi: layout, Users, Branches & teams, Audit log (en — manba)
export default {
  tabs: {
    users: "Users",
    branches: "Branches",
    settings: "Settings",
    import: "Sheets import",
    audit: "Audit log",
  },
  audit: {
    title: "Audit log",
    ownerOnly: "Owner only",
    ownerOnlyDesc: "The audit log is available to the owner.",
    readOnly: "Read-only",
    subtitle: "Every change in the system · owner only",
    userAll: "User: all",
    modelAll: "Object type: all",
    actionPlaceholder: "Action (update, login…)",
    searchPlaceholder: "Search object, driver name, ID",
    emptyTitle: "No events",
    emptyFiltered: "Nothing matches these filters.",
    emptyDesc: "Changes will appear here as people work.",
    col: { time: "Time", user: "User", action: "Action", object: "Object", change: "Change (old → new)", ip: "IP" },
    events: "events",
    system: "system",
    yes: "yes",
    no: "no",
    more: "+{{n}} more",
    requestId: "Request ID",
    field: "Field",
    old: "Old",
    new: "New",
    immutable: "Audit log entries cannot be edited or deleted.",
    model: {
      all: "All objects",
      auth: "Auth",
      user: "User",
      branch: "Branch",
      driver: "Driver",
      application: "Application",
      carrier: "Carrier",
      job: "Job",
      approval: "Approval",
      setting: "Settings",
      expense: "Expense",
      salary: "Salary",
      bonus: "Bonus",
      driverdocument: "Driver document",
    },
  },
  branches: {
    title: "Branches",
    subtitle_one: "{{count}} branch · {{recruiters}} recruiters",
    subtitle_other: "{{count}} branches · {{recruiters}} recruiters",
    newBranch: "+ New branch",
    emptyTitle: "No branches yet",
    emptyDesc: "Create the first branch, then add recruiters.",
    card: "Branches",
    col: { branch: "Branch", manager: "Managers", timezone: "Time zone", recruiters: "Recruiters" },
    tz: {
      title: "Time zones",
      branchTime: "Branch time",
      branchTimeDesc: "Each branch has its own time zone (above)",
      driverTime: "Driver time",
      driverTimeDesc: "From the driver's state: CST, EST, MST, PST",
      reminders: "Reminders",
      remindersDesc: "Set in the driver's time, shown in both",
      today: "“Today” in reports",
      todayDesc: "Branch time",
      tashkent: "Tashkent",
      chicago: "Chicago",
      newYork: "New York",
      losAngeles: "Los Angeles",
    },
    kv: { manager: "Managers", timezone: "Time zone", hours: "Working hours", address: "Address", recruiters: "Recruiters" },
    assignHint: "Managers and recruiters are assigned in Users → Edit.",
    managerHint: "Managers are assigned in Users → Edit.",
    editTitle: "Edit {{name}}",
    newTitle: "New branch",
    create: "Create branch",
    name: "Name",
    namePlaceholder: "Branch E",
    code: "Code",
    codePlaceholder: "E",
    hoursHint: "For example 17:00–02:00 Tashkent (drivers' day)",
    nameRequired: "Name is required.",
    codeRequired: "Code is required.",
    saved: "Branch saved",
    created: "Branch created",
    saveFailed: "Could not save the branch.",
  },
  users: {
    title: "Users",
    subtitle_one: "{{count}} users · {{branches}} branch",
    subtitle_other: "{{count}} users · {{branches}} branches",
    newUser: "+ New user",
    searchPlaceholder: "Search name or username",
    roleAll: "Role: all",
    branchAll: "Branch: all",
    statusAll: "Status: all",
    active: "Active",
    blocked: "Blocked",
    emptyFiltered: "No users match these filters",
    emptyTitle: "No users yet",
    emptyDesc: "Add your team with “+ New user”.",
    col: { name: "Name", role: "Role", branch: "Branch", drivers: "Drivers", lastLogin: "Last login", twofa: "2FA", status: "Status", actions: "Actions" },
    never: "Never signed in",
    alsoIn: "also {{names}}",
    on: "On",
    off: "Off",
    users: "users",
    unblock: "Unblock",
    block: "Block",
    cannotBlockSelf: "You cannot block yourself",
    moreActions: "More actions",
    setPassword: "Set new password…",
    reset2fa: "Reset 2FA",
    unblocked: "{{name}} unblocked",
    passwordSet: "New password set for {{name}}",
    twofaReset: "2FA reset for {{name}}",
    actionFailed: "Action failed",
    form: {
      editTitle: "Edit {{name}}",
      newTitle: "New user",
      newDesc: "You set a temporary password and pass it on; the user changes it at first sign-in.",
      create: "Create user",
      firstName: "First name",
      lastName: "Last name",
      username: "Username",
      usernamePlaceholder: "name.surname",
      password: "Temporary password",
      passwordHint: "At least 10 characters. You will see it once more after saving.",
      random: "Random",
      role: "Role",
      phone: "Phone",
      branch: "Branch",
      chooseBranch: "Choose a branch",
      extraBranches: "Additional branches",
      extraBranchesHint: "Besides the main branch. A branch can have several managers.",
      nothingToChoose: "Nothing to choose yet.",
      firstNameRequired: "First name is required.",
      usernameInvalid: "3-30 characters: lowercase latin letters, digits, dot, underscore or hyphen.",
      passwordShort: "At least 10 characters.",
      branchRequired: "Branch is required for this role.",
      saved: "User saved",
      created: "User created",
    },
    credentials: {
      title: "Sign-in details: {{name}}",
      desc: "Shown once. Hand them over in person or in a private message; the user sets their own password at first sign-in.",
      username: "Username",
      password: "Temporary password",
      copyAll: "Copy both",
      done: "Done",
    },
    setPasswordModal: {
      title: "New password for {{name}}",
      desc: "The current password stops working at once. The user changes this one at first sign-in.",
      password: "Temporary password",
      random: "Random",
      save: "Set password",
      failed: "Could not set the password.",
      saveFailed: "Could not save the user.",
    },
    blockModal: {
      title: "Block {{name}}?",
      blockReassign: "Block and reassign",
      block: "Block",
      body: "{{name}} will be signed out and can no longer log in. Nothing is deleted: history and audit log stay.",
      work: "What happens to {{first}}'s work",
      drivers_one: "{{count}} driver",
      drivers_other: "{{count}} drivers",
      reassignAll: "Reassign all to one recruiter",
      chooseRecruiter: "Choose a recruiter",
      returnToPool: "Return to the {{branch}} pool ({{manager}} assigns)",
      noDrivers: "No drivers to reassign.",
      notify: "Notify {{manager}} and the new owner",
      notifyManager: "Notify {{manager}}",
      chooseRecruiterError: "Choose a recruiter to receive the drivers.",
      blocked: "{{name}} blocked.",
      moved_one: "{{count}} driver moved.",
      moved_other: "{{count}} drivers moved.",
      failed: "Could not block the user.",
    },
  },
  // Ruxsatlar oynasi (owner): filial menejeri va team lead uchun
  access: {
    open: "Permissions",
    title: "Permissions · {{name}}",
    intro: {
      branch_manager: "A branch manager sees only their own branches. Choose what is open to them inside them.",
    },
    groups: { sections: "Sections", drivers: "Drivers", carriers: "Carriers and jobs" },
    perm: {
      reports: { label: "Reports", desc: "Reports page for their branch" },
      approvals: { label: "Approvals", desc: "Sees and decides hire, transfer and expense requests. When off, requests go to the owner." },
      budget: { label: "Budget and expenses", desc: "Branch budget overview, plan and expenses" },
      pay: { label: "Salaries and bonuses", desc: "Sees and sets staff salaries and bonuses, also on profiles" },
      users: { label: "Staff management", desc: "Admin → Users: adds, edits and blocks recruiters" },
      drivers_sensitive: { label: "Sensitive data", desc: "Sees and edits the full date of birth and CDL number" },
      drivers_transfer: { label: "Transfer drivers", desc: "Moves a driver to another recruiter or to the pool" },
      drivers_archive: { label: "Archive drivers", desc: "Archives drivers and restores them from the archive" },
      carriers_edit: { label: "Add and edit", desc: "Adds, edits and archives carriers and jobs. Everyone can view them." },
    },
    custom: "custom",
    customHint: "Permissions differ from the role defaults",
    reset: "Reset to role defaults",
    applyNote: "Changes apply at once; the person does not need to sign in again.",
    saved: "Permissions saved · {{name}}",
    conflict: "Someone changed these permissions a moment ago. The latest version is shown.",
    notEditable: "Permissions are set only for branch managers.",
    roleChangeHint: "Changing the role resets custom permissions to the new role's defaults.",
  },
};
